<template>
  <br />
  <form @submit.prevent="handleSubmit">
    <div class="form-check">
      <div
        class="form-group form-check"
        v-for="item in toBeShowItems"
        v-bind:key="item.id"
      >
        <label class="special-label">{{ item.text }} </label>
      </div>
      <br />
      <div
        class="form-group"
        v-for="(item, index) in OptionalItems"
        v-bind:key="item.id"
        v-show="false"
      >
        <input
          type="checkbox"
          v-model="TCcollection"
          :id="index"
          :value="item"
          @click="updateTC"
        />
        <label class="special-label" :for="index">{{ item.text }}</label>
      </div>
      <input
        type="checkbox"
        v-model="TCcollection"
        :id="GeneralTC[0]"
        :value="GeneralTC"
        @click="updateTC"
      />
      <label class="form-check-label"> General terms and conditions:</label>

      <li
        class="tclist"
        v-for="(gtc, index) in GeneralTC.tcs.tennis"
        v-bind:key="gtc.id"
      >
        <label>{{ index + 1 }} . {{ gtc }}</label>
      </li>
    </div>
  </form>
</template>

<script>
import {
  GeneralTerms,
  DefaultOptionalItems,
  DefaultTCItems,
  DefaultTCcollection,
} from '../../../../appterms';
export default {
  emits: ['tc-ticked'],

  data() {
    return {
      isFCHQ: false,
      currentRoute: null,
      currentPath: null,
      compulsoryAgreed: null,
      toBeShowItems: null,

      GeneralTC: GeneralTerms,

      OptionalItems: DefaultOptionalItems,

      TCItems: DefaultTCItems,

      TCcollection: DefaultTCcollection,
    };
  },
  methods: {
    /*
    inlineHyperLinkMaker(text) {
      if (text.indexOf('fairfieldcity.nsw.gov.au') > 0) {
        return (
          <a v-bind:href="'https://www.fairfieldcity.nsw.gov.au/futsal'">
            www.fairfieldcity.nsw.gov.au/FCHQ
          </a>
        );
      }

      return text;
    },
  */
    handleSubmit() {
      //  alert(JSON.stringify(this.user));
    },

    updateTC(event) {
      //console.log('starting check change ', event.target.checked);

      if (event.target.checked) {
        //   console.log(
        //     'starting with date change ',
        //    JSON.parse(JSON.stringify(this.TCcollection))
        //   );
      }

      // console.log('starting before change ', this.TCcollection);
    },
  },
  watch: {
    compulsoryAgreed() {
      //  console.log('TC agreed ', this.compulsoryAgreed);
      if (this.compulsoryAgreed) {
        this.$emit('tc-ticked', JSON.parse(JSON.stringify(this.TCcollection)));
      } else {
        this.$emit('tc-ticked', null);
      }
    },

    TCcollection() {
      //    console.log('TC picked', this.TCcollection);
      if (this.TCcollection.length == 0) {
        this.compulsoryAgreed = false;
      }

      for (var element of this.TCcollection) {
        if (element.Compulsory != undefined) {
          //  console.log('print true', element.Compulsory);
          this.compulsoryAgreed = element.Compulsory;
          return;
        } else {
          //  console.log('print undefined', element.Compulsory);
          this.compulsoryAgreed = false;
        }
      }

      /*
      this.TCcollection.find(element => {
        this.compulsoryAgreed = element.Compulsory;
        console.log('TC agreed index', this.compulsoryAgreed);
      });

      */
    },

    currentRoute() {
      //  console.log('routing updated', this.currentRoute.path);

      this.currentPath = this.currentRoute.path;
      //  console.log('this current path', this.currentPath);
        this.isFCHQ = false;
        this.toBeShowItems = this.TCItems;
    },
  },

  beforeMount() {
    this.currentRoute = this.$router.currentRoute;
  },

  //TODO , add a watch to update all the condition test
};
</script>

<style scoped>
li,
label {
  list-style-type: none;
  margin-left: 0.5rem;
  margin-bottom: 0.2rem;
  font-size: 80%;
}

.special-label {
  font-size: 70%;
  margin-left: 1rem;
  margin-right: 3rem;
  display: inline-flex;
}
</style>
